import { render } from "./FieldWrapper.vue?vue&type=template&id=77dfe72c"
import script from "./FieldWrapper.vue?vue&type=script&lang=js"
export * from "./FieldWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"FieldWrapper.vue"]])

export default __exports__